<div>
  <ag-grid-angular
    #locationListGrid
    [rowData]="locationGroupLocations()"
    [columnDefs]="locationGroupColumns"
    [gridOptions]="tableDef"
    [loading]="isLoading()"
    class="w-full"
  ></ag-grid-angular>
</div>

<app-pan-modal #addLocationToGroup [topLevel]="false" data-testid="add-location-to-group-modal">
  <div header>Add Location To Group</div>

  <div body class="flex flex-col gap-2">
    <app-page-select-branch [(selected)]="currentBranch"></app-page-select-branch>

    @if (currentBranch()) {
      <app-page-select-location
        [(selected)]="currentLocation"
        [branchId]="currentBranch()?.id"
        [locationFilterFn]="locationFilterFn"
      ></app-page-select-location>
    }
  </div>

  <div footer class="flex gap-2">
    <button panButton panModalClose data-testid="add-location-to-group-cancel">Cancel</button>
    <button
      panButton
      color="primary"
      (click)="locationGroupAddLocation()"
      [disabled]="!currentLocation()"
      data-testid="add-location-to-group-submit"
    >
      Add Location To Group
    </button>
  </div>
</app-pan-modal>
